// ForgotPasswordPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // For linking back to login
import useLocale from '../hooks/useLocale'; // Assuming path is correct

import axios from 'axios'; // We'll use this later
// Optional: Add CSS import if you have one for this page
import './forgot-password.css';

function ForgotPassword() { // <--- Renamed component function
    const { t } = useLocale();
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage(''); // Clear previous messages
    
        // Optional: Basic frontend email format check
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
         if (!emailRegex.test(email)) {
             setMessage(t('error_invalid_email_format', 'Please enter a valid email address.'));
             setIsLoading(false);
             return;
         }
    
        try {
            // --- Make the actual API call ---
            console.log(`[ForgotPassword] Sending request to /api/forgot-password for email: ${email}`);
            // Ensure this URL is correct for your setup
            const response = await axios.post('/api/forgot-password', { email: email });
    
            // Use the generic success message returned by the backend
            const messageCode = response.data?.messageCode; // Get the code from the response

            t(messageCode || 'API_AUTH_FORGOT_PASSWORD_SENT', 'If an account with that email address exists, a password reset link has been sent.')
            setEmail(''); // Clear the email field after submission attempt
    
        } catch (error) {
            // Handle network errors or 500 errors from the backend
            const errorCode = error.response?.data?.errorCode;
            const messageKey = errorCode || 'AUTH_ERROR_GENERIC_REQUEST_FAILED'; // Define a new key for generic failures

            console.error("Forgot password API call failed:", error.response || error);
            setMessage(
                t(messageKey, // Use the specific code if available, otherwise the generic one
                    'Request failed. Please check input or connection and try again.' // Final fallback text
                   )
            );
        } finally {
            // Ensure loading state is turned off
            setIsLoading(false);
        }
    }; // --- End of updated handleSubmit ---

    return (
        <div> {/* Or a more specific container component */}
            <h2>{t('auth_forgot_password_title', 'Forgot Password')}</h2>
            
            
    
            <p>{t('auth_forgot_password_instructions', 'Enter the email address associated with your account, and we will send you a link to reset your password.')}</p>
    
            <form onSubmit={handleSubmit} className="forgot-password-form">
                <div className="form-group">
                    <label htmlFor="email">{t('auth_forgot_password_email_label', 'Email Address')}:</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={isLoading}
                    />
                </div>
    
                <button type="submit" disabled={isLoading}>
                {isLoading ? t('common_loading', 'Sending...') : t('auth_forgot_password_button', 'Send Reset Link')}
                </button>
            </form>
    
            {/* Display Success/Error Messages - Uses CSS classes */}
            {message && (
                <p className={`form-message ${message.includes('Failed') ? 'error' : 'success'}`}>
                    {message}
                </p>
            )}
    
            {/* Link back to Login - Uses CSS class on container */}
            <p className="form-link-container"> {/* Apply class to container P tag */}
                <Link to="/login" className="app-link"> {/* Link uses its own class */}
                    {t('auth_forgot_password_back_link', 'Back to Login')}
                </Link>
            </p>
        </div>
    );
}

export default ForgotPassword;